import useSwr from "swr";

const FetchTypeLines = () => {
  let url = `${process.env.REACT_APP_URL_BACKEND}api/v1/type-lines`;
  const { data, error } = useSwr(url);
  return { data, error };
};

export default FetchTypeLines;
